import React, { useState , useEffect} from "react";
import styles from "./login.module.scss"
import logoImg from "../../app/images/logo.png"
import {Box, TextField, FormControlLabel, Checkbox, Button, Typography} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { login } from "../../app/data/api";

const LogIn: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const data = await login(username, password);
      console.log('data: ', data)
      localStorage.setItem("token", data.access_token); 
      console.log('localStorage:',localStorage);
      navigate("/"); 
    } catch (err: any) {
      setError(err.response?.data?.message || "Login failed");
    }
  };
  useEffect(() => {
    const handlePopState = () => {
      const token = localStorage.getItem("token");
      if (!token) {
        window.history.pushState(null, "", "/login");
        alert("You cannot leave this page without logging in.");
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperInner}>
        <div className={styles.logoWrap}>
            <img src={logoImg} alt="logoImg"/>
        </div>
        <h3 className={styles.title}>Sign In</h3>
        <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: "24px",
        width: "100%",
        mx: "auto",
      }}
    >
         {error && <Typography color="error">{error}</Typography>}
      <TextField
        label="Username"
        variant="outlined"
        placeholder="Enter username"
        InputLabelProps={{ shrink: true }}
        fullWidth
        value={username}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "#3C3D3B" }, // Default border
            "&:hover fieldset": { borderColor: "#3C3D3B" }, // Hover border
            "&.Mui-focused fieldset": { borderColor: "#3C3D3B" }, // Focus border
          },
          "& .MuiInputBase-input": {
            color: "#3C3D3B", 
          },
          "& .MuiInputLabel-root": {
            color: "#3C3D3B", 
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#3C3D3B", 
          },
        }}
        onChange={(e) => setUsername(e.target.value)}
      />

      <TextField
        label="Password"
        variant="outlined"
        type="password"
        InputLabelProps={{ shrink: true }}
        placeholder="Enter password"
        fullWidth
        value={password}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "#3C3D3B" }, // Default border
            "&:hover fieldset": { borderColor: "#3C3D3B" }, // Hover border
            "&.Mui-focused fieldset": { borderColor: "#3C3D3B" }, // Focus border
          },
          "& .MuiInputBase-input": {
            color: "#3C3D3B", 
          },
          "& .MuiInputLabel-root": {
            color: "#3C3D3B", 
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#3C3D3B", 
          },
        }}
        onChange={(e) => setPassword(e.target.value)}
      />
      <div className={styles.detailsWrap}>
        <FormControlLabel
          control={<Checkbox className={styles.checkBox} size="small" color="primary" sx={{ transform: "scale(0.8)", fontSize: "10px" , "@media (max-width: 600px)": { transform: "scale(0.5)" } }} />}
          label="keep me logged in"
          sx={{ 
            gap: "0px",       
            "& .MuiTypography-root": { 
              fontSize: "14px", 
              "@media (max-width: 600px)": { fontSize: "12px" } 
            } 
          }}
        />
        <Link to="" className={styles.forgotLink} >
         forgot password?
        </Link>
      </div>

      <Button
        variant="contained"
        color="error"
        fullWidth
        sx={{ borderRadius: "10px", width: "162px", height: "40px", fontSize: "16px", fontWeight: "600", margin: "0 auto" }}
        onClick={handleSubmit}
      >
        Log In
      </Button>
        </Box>
        <div className={styles.optionsWrap}>
          <p>Don’t have an account?</p>
          <Link className={styles.optionsLink} to="/signup">Sign up  <ArrowForwardIcon /></Link>
        </div>
       
      </div>
    </div>
  );
};

export default LogIn;